import 'regenerator-runtime/runtime'
import 'whatwg-fetch'
import './i18n/i18n'

import { internalFrontendSentryAPIKey, isProduction, sentryEnvironment } from '@glow/common'
import { setupAtPolyfill } from '@glow/common/utils/atPolyfill'
import { initializeSiteAnalytics, initializeSiteMetrics, type SampleRules } from '@glow/instrumentation'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { fetchUser } from './actions/creators/user'
import { checkRevision } from './checkRevision'
import { App } from './components/App'
import './index.css'
import { store } from './reducers/store'
import { basePath } from './utils/appBase'
import { printConsolePortrait } from './utils/consolePortrait'
import { initErrorHandlers } from './utils/errorHandlers'

initErrorHandlers()
printConsolePortrait()

if (isProduction()) {
  initializeSiteAnalytics()
}

const apolloDepartments = [
  678, 687, 226, 765, 766, 767, 768, 685, 704, 706, 713, 623, 705, 771, 686, 281, 757, 758, 676, 759, 760, 454, 499,
  761, 762, 763, 764, 707
]

const sampleRules = apolloDepartments
  .map((department) => {
    return {
      [`/${department}/planning`]: 0.1,
      [`/${department}/dispatch`]: 0.1,
      [`/${department}/shipments-search`]: 0.1,
      [`/${department}/routes-overview`]: 0.1
    }
  })
  .reduce(
    (acc, pages) => {
      return { ...acc, ...pages }
    },
    { defaultSampleRate: 0 }
  ) as SampleRules

const apiKey = internalFrontendSentryAPIKey()
// A PR preview runs on the QA host, but its errors belong to the PR, not to QA's Sentry
if (apiKey && !basePath()) {
  initializeSiteMetrics(apiKey, sentryEnvironment(), sampleRules)
}

if (import.meta.env.MODE === 'mock') {
  const { startMockWorker } = await import('../mock-data/browser')
  await startMockWorker()
}

checkRevision(store.dispatch)

// httpHelper already logs the failure and sends a 401 to login
fetchUser()(store.dispatch).catch(() => {})
setupAtPolyfill()

const container = document.getElementById('app')
const root = createRoot(container!)
root.render(
  <StrictMode>
    <App />
  </StrictMode>
)
